import React, { useState } from 'react';
import { supabase } from '../supabase';

export default function GameEnd({ score, difficulty, qualifies, onLeaderboard, onPlay, onMenu }) {
  const [nameInput, setNameInput] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(null);

  async function handleSubmit() {
    const name = nameInput.trim() || 'Unknown Hero';
    setSubmitting(true);
    setError(null);
    try {
      const { error } = await supabase
        .from('leaderboard')
        .insert([{ name, score, difficulty }]);

      if (error) throw error;
      setSubmitted(true);
      setTimeout(() => onLeaderboard(), 1000);
    } catch (err) {
      console.error(err);
      setError('Failed to save score. Check your Supabase connection.');
      setSubmitting(false);
    }
  }

  return (
    <div className="card round-wrap fade-in">
      <p className="title" style={{ fontSize: 14, letterSpacing: 6, color: 'var(--gold)' }}>GAME OVER</p>
      <div className="divider" />
      <div className="big-score">{score.toLocaleString()}</div>
      <p style={{ color: 'var(--muted)', marginBottom: 28, fontFamily: "'Rajdhani', sans-serif", letterSpacing: 2 }}>
        FINAL SCORE
      </p>

      {qualifies && !submitted ? (
        <>
          <p style={{ color: 'var(--gold)', marginBottom: 16, fontWeight: 700 }}>🏆 You made the leaderboard!</p>
          <input
            className="name-input"
            placeholder="Enter your hero name..."
            value={nameInput}
            onChange={(e) => setNameInput(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && !submitting && handleSubmit()}
            maxLength={20}
            autoFocus
            disabled={submitting}
          />
          {error && <p style={{ color: 'var(--red)', fontSize: 12, marginTop: 8 }}>{error}</p>}
          <div style={{ display: 'flex', gap: 10, marginTop: 14 }}>
            <button className="btn btn-primary" onClick={handleSubmit} style={{ flex: 1, fontSize: 18 }} disabled={submitting}>
              {submitting ? 'SAVING...' : 'SUBMIT'}
            </button>
            <button className="btn" onClick={onMenu} style={{ flex: 1, fontSize: 18 }}>SKIP</button>
          </div>
        </>
      ) : submitted ? (
        <p style={{ color: '#4caf50', fontWeight: 700, letterSpacing: 2, fontFamily: "'Rajdhani'" }}>✓ SCORE SAVED! LOADING LEADERBOARD...</p>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <button className="btn btn-primary" onClick={onPlay} style={{ fontSize: 18 }}>⚡ PLAY AGAIN</button>
          <button className="btn btn-gold" onClick={onLeaderboard} style={{ fontSize: 18 }}>🏆 LEADERBOARD</button>
          <button className="exit-btn" onClick={onMenu} style={{ margin: '0 auto' }}>MENU</button>
        </div>
      )}
    </div>
  );
}
